import React, { useRef } from 'react';
import './VideoUploader.css';

export function VideoUploader({ videoFile, onFileSelect, onClear, error }) {
  const fileInputRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      onFileSelect(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      onFileSelect(e.target.files[0]);
    }
  };

  if (videoFile) {
    return (
      <div className="video-file-badge">
        <span className="video-file-badge__name">{videoFile.name}</span>
        <button
          type="button"
          className="video-file-badge__clear"
          onClick={onClear}
          title="다른 영상 선택"
        >
          삭제
        </button>
      </div>
    );
  }

  return (
    <div
      className="video-uploader"
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
      onClick={() => fileInputRef.current?.click()}
    >
      <input
        ref={fileInputRef}
        type="file"
        accept="video/*"
        className="video-uploader__input"
        onChange={handleChange}
      />
      <p className="video-uploader__text">
        <strong>양궁 촬영 동영상 파일</strong>을 드래그하거나 클릭하여 업로드
      </p>
      <span className="video-uploader__hint">MP4, WebM, MOV 지원 (100% 브라우저 로컬 분석)</span>
      {error && <p className="video-uploader__error">{error}</p>}
    </div>
  );
}
